export default "__VITE_ASSET__BknJQXKF__"